import React, { Component } from "react";

import Lightbox from "./Lightbox";

export { default as Lightbox } from "./Lightbox";

export default class ModalImage extends Component {
  state = { modalOpen: false };

  toggleModal = () => {
    // this.setState(prev => ({
    //   modalOpen: !prev.modalOpen
    // }));
    window.open(this.props.link, "_blank")
  };

  render() {
    const {
      className,
      small,
      smallSrcSet,
      medium,
      large,
      alt,
      hideDownload,
      hideZoom,
      showRotate,
      imageBackgroundColor,
      onLeftArrowClick,
      onRightArrowClick
    } = this.props;
    const { modalOpen } = this.state;

    return (
      <div>
        <img
          className={className}
          style={{
            cursor: "pointer",
            maxWidth: "100%",
            maxHeight: "100%"
          }}
          onClick={this.toggleModal}
          src={small}
          srcSet={smallSrcSet}
          alt={alt}
        />
        {modalOpen && (
          <Lightbox
            medium={medium}
            large={large}
            alt={alt}
            onClose={this.toggleModal}
            hideDownload={hideDownload}
            hideZoom={hideZoom}
            showRotate={showRotate}
            imageBackgroundColor={imageBackgroundColor}
            onLeftArrowClick={onLeftArrowClick}
            onRightArrowClick={onRightArrowClick}
          />
        )}
      </div>
    );
  }
}
